import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";
import utils from "../../utils/utils";
import validationHelper from "../../utils/validationHelper";
import PainSelfMedicalInfoTab from "./PatientTabs/PainSelfMedicalInfoTab";
import AlertConfirm from "../../components/modals/Confirm";
import PainSelfUseOfCannabisTab from "./PatientTabs/PainSelfUseOfCannabisTab";
import patientApi from "../../services/ApiServices/patientApi";
import {authenticationService} from "../../services/AuthenticationService";
import PainSelfPersonalDetailsTab from "./PatientTabs/PainSelfPersonalDetailsTab";
import PainProgrammChooseTab from "./PatientTabs/PainProgrammChooseTab";
import {makeError} from "../../components/modals/ErrorModal";
import {history} from "../../utils/history";
import PainSelfDeclarationTab from "./PatientTabs/PainSelfDeclarationTab";
import SvGraphics from "../../assets/SvGraphics";
import * as Yup from "yup";
import LeumitPayment from "../../components/Leumit_Patient_SelfOnboard/LeumitPayment";
import LeumitLogo from "../../assets/LeumitLogo.png"
import {hasIchilovQuery} from "../../utils/routeUtils";


class LeumitPatientSelfOnBoardConnected extends Component {
    constructor(props) {
        super(props);
        this.state = {
            entry: {
                Phone_num1: "",
                Last_name: "",
                First_name: "",
                Phone_num2: "",
                House_number: "",
                Email: null,
                ID_passport: "",
            },
            view: 1,
            errors: {},
            errorsOnSave: {},
            patientQuestionnaire: {},
            transporterFormIndex: null,
            psychiatricFormIndex: null,
            israelCities: [],
            addedProducts: [],
            checkboxes: {},
            productsList: [],
            medicalConditions: [],
            medicalConditionsSelected: [],
            allergics: [],
            patient_allergics: [],
            medicationsList: [],
            fileForms: [],
            otherForms: [],
            general_medications: [],
            bloodThinner_medications: [],
            currentPain_medications: [],
            past_med: [],
            addedFilesList: [],
            filesToUpload: [],
            filesErrorOnSave: false,
            isUploadingFiles: false,
            editMode: false,
            isPageUploading: true,
            docWidth: document.body.offsetWidth,
        }
    }

    async componentDidMount() {
        const self = this;
        window.addEventListener('resize', function (event) {
            self.setState({docWidth: document.body.offsetWidth})
        }, true);

        let {
            general_medications, bloodThinner_medications, currentPain_medications,
            past_med, israelCities, productsList, medicationsList,
            allergics, medicalConditions, fileForms, otherForms
        } = this.state

        let allData = (await patientApi.getAllData())

        if (allData) {
            allData = allData.data
            israelCities = allData.cities
            productsList = allData.products
            medicationsList = allData.medications
            allergics = allData.allergics
            medicalConditions = allData.medicalConditions
            fileForms = allData.formsLeumit
            otherForms = allData.forms
        }
        this.setState({
            productsList, allergics, medicalConditions, fileForms,
            medicationsList, israelCities, otherForms
        })


        let currentUser = authenticationService.currentUserValue;
        let info = currentUser ? (await patientApi.getPatientById(currentUser.profile.UserStorageID)) : ""
        info = info ? info.data : []
        let PII = info.PII ? info.PII : {}
        if (PII.Date_of_birth) {
            PII.Date_of_birth = new Date(PII.Date_of_birth)
        }
        let hasOldRequest = info.hasOldRequest
        let patientRequests = info ? info.Patient_requests : []
        info = patientRequests && patientRequests.length >= 1 ? patientRequests[patientRequests.length - 1] : []

        let Habits_Medicals = ""
        if (info.Habits_Medicals) {
            Habits_Medicals = info.Habits_Medicals.length > 0 ? info.Habits_Medicals[0] : []
        }


        let addedProducts = info.Patient_products ? info.Patient_products[0] : []
        let Patient_type_indication = info.Patient_type_indication ? info.Patient_type_indication[0] : []
        let patient_conditions = info.Patient_conditions ? info.Patient_conditions[0] : []

        let medicalConditionsSelected = []
        for (let i = 0; i < patient_conditions.length; i++) {
            medicalConditionsSelected.push({
                value: parseInt(patient_conditions[i].Condition_ID),
                label: this.getConditionDesc(patient_conditions[i].Condition_ID)
            })
        }


        for (let i = 0; i < addedProducts.length; i++) {
            addedProducts[i]['product_use_obj'] = {
                value: addedProducts[i].product_use,
                label: addedProducts[i].product_use
            }
            addedProducts[i].displayProducts = this.onclickChoosedCategory(addedProducts[i].product_use_category, addedProducts[i].product_type)
        }

        if (PII.Date_of_birth) {
            PII.Date_of_birth = new Date(PII.Date_of_birth)
        }


        let entry = {...PII, ...Habits_Medicals, ...Patient_type_indication, ...info}
        entry['MediatorCode'] = ""
        entry['hasOldRequest'] = hasOldRequest
        entry['hasLicenseLastYear'] = entry['toPay'] ? entry['hasLicenseLastYear'] : ""
        let pAllergics = Habits_Medicals['patient_allergics'] ? Habits_Medicals.patient_allergics : ""
        pAllergics = pAllergics ? pAllergics.split(',') : ""

        let patient_allergics = []
        for (let i = 0; i < pAllergics.length; i++) {
            let index = parseInt(pAllergics[i])
            patient_allergics.push({value: index, label: this.getAllergicDesc(index)})
        }


        let medications = info.Patient_Medications ? info.Patient_Medications : []
        let isOtherPastUseMedication = false

        for (let i = 0; i < medications.length; i++) {
            if (medications[i].General_Thinner_Past === "Past") {
                if (medications[i].Medication_name === "Other") {
                    isOtherPastUseMedication = true
                }
                past_med.push({value: parseInt(medications[i].Med_ID), label: medications[i].Medication_name})
            } else {
                medications[i].MedObj = {value: medications[i].Med_ID, label: medications[i].Medication_name}
                if (medications[i].General_Thinner_Past === "G") {
                    medications[i].index = general_medications.length
                    general_medications.push(medications[i])
                } else if (medications[i].General_Thinner_Past === "T") {
                    medications[i].index = bloodThinner_medications.length
                    bloodThinner_medications.push(medications[i])
                } else if (medications[i].General_Thinner_Past === "CP") {
                    medications[i].index = currentPain_medications.length
                    currentPain_medications.push(medications[i])
                }
            }
        }

        delete entry['Doctor_Indication']
        entry['RequestInfo'] = ""
        entry['PatientComments'] = ""
        entry['DeclarationAccept'] = entry.DeclarationAccept === 1
        entry['AcceptFutureContact'] = entry.AcceptFutureContact === 1

        entry.SelectedCity = {value: entry.cityID, label: this.getCityDesc(entry.cityID)}

        if (!this.state.editMode) {
            entry.choose_programm = ""
        }

        this.setState({
            entry,
            addedProducts,
            patient_allergics,
            medicalConditionsSelected,
            general_medications,
            bloodThinner_medications,
            currentPain_medications,
            past_med,
            isPageUploading: false
        })


    }

    getCityDesc = (val) => {
        let {israelCities} = this.state
        for (let j = 0; j < israelCities.length; j++) {

            if (israelCities[j].index.toString() === val) {
                return israelCities[j].cityName
            }
        }
    }

    deleteUploadedFile = async (index) => {
        this.setState({isUploadingFiles: true})
        let {addedFilesList, entry} = this.state
        let fileToDelete = addedFilesList[index]

        let res = await patientApi.deleteUploadedFiles(entry.UserStorageID, fileToDelete)
        if (res) {
            if (addedFilesList.length === 1) {
                addedFilesList = []
            } else {
                addedFilesList.splice(index, 1)
            }
        }
        this.setState({addedFilesList, isUploadingFiles: false})
    }

    getAllergicDesc = (index) => {
        let {allergics} = this.state
        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')
        for (let j = 0; j < allergics.length; j++) {
            if (allergics[j].index === index) {
                if (language === "he") {
                    return allergics[j].Allergic_name_he
                } else {
                    return allergics[j].Allergic_name
                }
            }
        }
    }

    getConditionDesc = (index) => {
        let {medicalConditions} = this.state
        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')
        for (let j = 0; j < medicalConditions.length; j++) {
            if (medicalConditions[j].Condition_ID.toString() === index.toString()) {
                if (language === "he") {
                    return medicalConditions[j].Condition_description_he
                } else {
                    return medicalConditions[j].Condition_description
                }
            }
        }
    }

    onclickChoosedCategory(category, type) {
        let {productsList} = this.state
        let displayProducts = []
        for (let i = 0; i < productsList.length; i++) {
            if ((category === productsList[i].Category && productsList[i].Strain === "Flower")
                || (category === productsList[i].Category && productsList[i].Strain === type)) {
                displayProducts.push(
                    {value: productsList[i].Product_name, label: productsList[i].Product_name})
            }
        }
        return displayProducts
    }

    changeView = async (viewNum) => {
        let {view, entry} = this.state
        let {t} = this.props
        if (entry.hasRequestWithinTwoMonths) {
            let confirm = await AlertConfirm({
                options: {
                    cancelLabel: "none",
                    title: '',
                }
            }, t('patient_boarding.requestWithinTwoMonthsError'))


        } else {
            let response = await this.saveAllPatientData("")
            if (response) {
                this.setState({view: viewNum})
            }
        }


    }

    initValidation = async () => {
        let {entry, view} = this.state
        let {t} = this.props
        let validationSchema
        switch (view.toString()) {
            case "1": {
                validationSchema = Yup.object().shape({
                    Doctor_Indication: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    hasLicenseLastYear: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    renewCurrentDose: Yup.string().when("hasLicenseLastYear", {
                        is: value => {
                            return value === "Yes"
                        },
                        then: (schema) => schema.nullable().required(t('defaults.Registration.mandatoryField')),
                        otherwise: (schema) => schema.nullable()
                    })
                })
                return await validationHelper.validate(entry, validationSchema)
            }
            case "2": {
                validationSchema = Yup.object().shape({
                    Gender: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    ID_passport: Yup.string().required(t('defaults.Registration.mandatoryField')).matches(/^\d+$/, t('defaults.Registration.digitsOnly')).test('len', 'Must be exactly 9 characters', val => val.length === 9),
                    House_number: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')).matches(/^\d*$/, t('defaults.Registration.digitsOnly')),
                    Phone_num2: Yup.string().matches(/^\d*$/, t('defaults.Registration.digitsOnly')).nullable(),
                    Systolic_blood_press_mmHg: Yup.string().matches(/^\d*$/, t('defaults.Registration.digitsOnly')).nullable(),
                    Diastolic_blood_press_mmHg: Yup.string().matches(/^\d*$/, t('defaults.Registration.digitsOnly')).nullable(),
                    Email: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')).matches(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'Mail is invalid').nullable(),
                    choose_programm: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Date_of_birth: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Marital_status: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Education: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Insuring_factor: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    First_name: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Last_name: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    cityID: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Employment_details: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Alcohol_usage: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Smoker: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Street_name: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Ministry_Interior_matters: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Phone_num1: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')).matches(/^\d+$/, t('defaults.Registration.digitsOnly')),
                    Driving: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Commercial_license: Yup.string().when("Driving", {
                        is: value => {
                            return value === "Yes"
                        },
                        then: (schema) => schema.nullable().required(t('defaults.Registration.mandatoryField')),
                        otherwise: (schema) => schema.nullable()
                    }),
                    Pregnant: Yup.string().when(['Gender', 'Date_of_birth'], {
                        is: (gender, birthdate) => {
                            let today = new Date()
                            let birthDate = new Date(birthdate)
                            return gender === 'Female' && birthdate && today.getFullYear() - birthDate.getFullYear() < 50;
                        },
                        then: (schema) => schema.nullable().required(t('defaults.Registration.mandatoryField')),
                        otherwise: (schema) => schema.nullable()
                    }),
                    Breast_feeding: Yup.string().when(['Gender', 'Date_of_birth'], {
                        is: (gender, birthdate) => {
                            let today = new Date()
                            let birthDate = new Date(birthdate)
                            return gender === 'Female' && birthdate && today.getFullYear() - birthDate.getFullYear() < 50;
                        },
                        then: (schema) => schema.nullable().required(t('defaults.Registration.mandatoryField')),
                        otherwise: (schema) => schema.nullable()
                    }),

                })
                return await validationHelper.validate(entry, validationSchema)
            }
            case "3": {
                let validationSchema = Yup.object().shape({
                    transporter: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    doctors_referral_name: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Drug_abuse: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Nuclear_family_psychosis: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    Psychiatric_diagnosis: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    SuffersBloodPressure: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    SuffersDiabetes: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                    transporterName: Yup.string().when("transporter", {
                        is: value => {
                            return value === "Yes"
                        },
                        then: (schema) => schema.nullable().required(t('defaults.Registration.mandatoryField')),
                        otherwise: (schema) => schema.nullable()
                    })
                })

                let error = await validationHelper.validate(entry, validationSchema)

                if (!this.state.patient_allergics.length > 0 && view === 3) {
                    error['patient_allergics'] = [t('defaults.Registration.mandatoryField')]
                } else {
                    delete error['patient_allergics']
                }
                return error
            }
            case "4": {
                let validationSchema = Yup.object().shape({
                    Smoked_cannabis: Yup.string().nullable().required(t('defaults.Registration.mandatoryField')),
                })
                return await validationHelper.validate(entry, validationSchema)
            }
            case "5": {
                let validationSchema = Yup.object().shape({
                    DeclarationAccept: Yup.bool().oneOf([true], t('defaults.Registration.mandatoryField')),
                    AcceptFutureContact: Yup.bool().oneOf([true], t('defaults.Registration.mandatoryField')),
                })
                return await validationHelper.validate(entry, validationSchema)
            }

            default:
                return ""
        }

    }

    addTransporterForm = (value) => {
        let {filesToUpload, fileForms, transporterFormIndex} = this.state
        if (value) {
            if (!this.checkIfFileExists(fileForms[transporterFormIndex].Form_type_ID)) {
                filesToUpload.push({
                    Form_type_ID: fileForms[transporterFormIndex].Form_type_ID,
                    FormOrder: fileForms[transporterFormIndex].FormOrder,
                    FileUrl: [],
                    File_Name: [],
                    Form_desc: this.getFileFormDesc(transporterFormIndex)
                })
            }
        } else {
            for (let i = 0; i < filesToUpload.length; i++) {
                if (filesToUpload[i].Form_type_ID.toString() === fileForms[transporterFormIndex].Form_type_ID.toString()) {
                    filesToUpload.splice(i, 1)
                }

            }
        }
        if (filesToUpload && filesToUpload.length > 0) {
            filesToUpload.sort((a, b) => a.FormOrder - b.FormOrder);
        }
    }

    addPsychiatricForm = (value) => {
        let {filesToUpload, fileForms, psychiatricFormIndex} = this.state
        if (value) {
            if (!this.checkIfFileExists(fileForms[psychiatricFormIndex].Form_type_ID)) {
                filesToUpload.push({
                    Form_type_ID: fileForms[psychiatricFormIndex].Form_type_ID,
                    FormOrder: fileForms[psychiatricFormIndex].FormOrder,
                    FileUrl: [],
                    File_Name: [],
                    Form_desc: this.getFileFormDesc(psychiatricFormIndex)
                })
            }
        } else {
            for (let i = 0; i < filesToUpload.length; i++) {
                if (filesToUpload[i].Form_type_ID.toString() === fileForms[psychiatricFormIndex].Form_type_ID.toString()) {
                    filesToUpload.splice(i, 1)
                }
            }
        }
        if (filesToUpload && filesToUpload.length > 0) {

            filesToUpload.sort((a, b) => a.FormOrder - b.FormOrder);
        }

    }

    onYesNoValueChange(variable, value) {
        let {entry} = this.state
        let isNewRequest = entry.choose_programm === "new" || entry.choose_programm === "newPrescription"
        let isRenew2Request = entry.choose_programm === "renew2" || entry.choose_programm === "renew2Prescription"
        let isRenewRequest = entry.choose_programm === "renew" || entry.choose_programm === "renewPrescription"

        if (variable === "transporter") {
            this.addTransporterForm(!(entry[variable] === value) && value === "Yes")
        } else if (variable === "Psychiatric_diagnosis") {
            this.addPsychiatricForm(
                ((!(entry[variable] === value) && value === "Yes") || entry.Drug_abuse === "Yes" || entry.Nuclear_family_psychosis === "Yes") &&
                (isNewRequest || isRenew2Request))
        } else if (variable === "Nuclear_family_psychosis") {
            this.addPsychiatricForm(
                ((!(entry[variable] === value) && value === "Yes") || entry.Drug_abuse === "Yes" || entry.Psychiatric_diagnosis === "Yes") &&
                (isNewRequest || isRenew2Request))
        } else if (variable === "Drug_abuse") {
            this.addPsychiatricForm(
                ((!(entry[variable] === value) && value === "Yes") || entry.Nuclear_family_psychosis === "Yes" || entry.Psychiatric_diagnosis === "Yes") &&
                (isNewRequest || isRenew2Request))
        } else if (variable === "Recommendation_letter_use_cannabis" && value === "No") {
            this.onValueChange("doctors_referral", "")
        }
        if (entry[variable] === value) {
            this.onValueChange(variable, "")
        } else {
            this.onValueChange(variable, value)
        }
    }

    onClickCheckboxes = async (name) => {
        let {checkboxes} = this.state
        if (checkboxes.hasOwnProperty(name)) {
            checkboxes[name] = !checkboxes[name]
        } else checkboxes[name] = true

        this.onValueChange(name, checkboxes[name])
        this.setState({checkboxes})
    }

    onClickDailyReport = async (value, questionId) => {
        let {patientQuestionnaire} = this.state
        patientQuestionnaire[questionId] = patientQuestionnaire[questionId] === value ? "" : value
        this.setState({patientQuestionnaire})
    }

    onValueChange = async (name, value) => {
        let {entry} = this.state
        if (name === "Email" && value === "") {
            value = null
        }
        utils.set(entry, name, value)
        let entryValidator = entry

        let errors = await this.initValidation();
        let errorsOnSave = this.state.errorsOnSave;

        if (JSON.stringify(errors) === '{}') {
            errorsOnSave = errors
        }

        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }

        this.setState({
            entry,
            errors,
            errorsOnSave
        })
    }

    onClickAddProducts = async (func, value, index) => {
        let {addedProducts} = this.state
        let tempEntry = {}
        let {t} = this.props
        if (func === "ADD") {
            if (addedProducts.length === 4) {
                await AlertConfirm({
                    options: {
                        title: '',
                    }
                }, t('patient_self_boarding.maxProd'))
            } else {
                tempEntry.index = addedProducts.length
                tempEntry.product_type = "Flower"
                tempEntry.product_use_category = ""
                tempEntry.product_use = ""
                tempEntry.displayProducts = []
                addedProducts.push(tempEntry)
            }
        } else if (func === "product_use_category") {
            addedProducts[index].product_use_category = value
            addedProducts[index].displayProducts = this.onclickChoosedCategory(value, addedProducts[index].product_type)
        } else if (func === "Delete") {
            addedProducts.splice(0, addedProducts.length)
        } else if (func === "product_use_obj") {
            addedProducts[index][func] = value
            addedProducts[index]['product_use'] = value.label

        } else {
            addedProducts[index][func] = value
        }
        this.setState({addedProducts})
    }

    nextButton = () => {
        let {view} = this.state
        let toView = view + 1
        this.changeView(toView)

    }

    backButton = () => {
        let viewNum = this.state.view

        if (viewNum !== 1) {
            this.changeView(viewNum - 1)

        }
        let elmntToView = document.getElementById('patientTabsMainBox');
        if (elmntToView)
            elmntToView.scrollIntoView();

    }

    saveAllPatientData = async (val) => {
        this.setState({isPageUploading: true})
        let {t} = this.props
        let {filesToUpload, view} = this.state
        let Couldnt_save_patient = t('patient_self_boarding.Couldnt_save_patient')
        let Couldnt_save_patient_message = t('patient_self_boarding.Couldnt_save_patient_message')
        let {
            entry, checkboxes, addedProducts, patient_allergics,
            past_med,
            general_medications,
            currentPain_medications,
            filesErrorOnSave,
            bloodThinner_medications, medicalConditionsSelected
        } = this.state


        let errors = await this.initValidation()

        if (val === "exit" || val === "RequestWithoutPayment" || view === 3) {
            for (let i = 0; i < filesToUpload.length; i++) {
                if (!filesToUpload[i].FileUrl.length > 0) {
                    errors['UploadFiles'] = ['all files are mandatory']
                    filesErrorOnSave = true
                }
            }
            if (!filesErrorOnSave) {
                filesErrorOnSave = false
                delete errors['UploadFiles']
            }
            this.setState({filesErrorOnSave})
        }


        if (!utils.isEmpty(errors)) {
            this.setState({errorsOnSave: errors, errors: errors, isPageUploading: false});
            await makeError({
                proceedLabel: t('patient_self_boarding.ok'),
                options: {
                    title: Couldnt_save_patient,
                }
            }, [Couldnt_save_patient_message]);
            return;
        }

        let allergics = ""
        if (patient_allergics) {
            for (let i = 0; i < patient_allergics.length; i++) {
                allergics = i === 0 ? patient_allergics[i].value : allergics + "," + patient_allergics[i].value
            }
        }
        entry = {...entry, ...checkboxes}
        entry.patient_allergics = allergics

        let medications = []

        medications = medications.concat(general_medications, currentPain_medications, bloodThinner_medications)

        for (let i = 0; i < past_med.length; i++) {
            let a = {Med_ID: past_med[i].value, Medication_name: past_med[i].label, General_Thinner_Past: "Past"}
            medications.push(a)
        }

        entry['LastVisitDate'] = (new Date())
        entry['medications'] = medications
        entry['Patient_products'] = addedProducts
        entry['statusText'] = ""
        entry['medicalConditionsSelected'] = medicalConditionsSelected ? medicalConditionsSelected : []


        if (entry.Phone_num1 && !entry.Phone_num1.includes('972')) {
            entry.Phone_num1 = "972" + entry.Phone_num1.substring(1)
            this.onValueChange("Phone_num1", entry.Phone_num1)
        }

        if (!this.state.editMode) {
            delete entry['RequestID']
        }

        entry['DeclarationAccept'] = entry.DeclarationAccept === 1 || entry.DeclarationAccept
        entry['AcceptFutureContact'] = entry.AcceptFutureContact === 1 || entry.AcceptFutureContact

        entry['toPay'] = entry.toPay ? entry.toPay.toString() : "0"
        entry['addPayment'] = val === "exit" && entry.toPay.startsWith('0')
        entry['isFormFullyFilled'] = (val === "exit" && entry.toPay.startsWith('0') || val === "RequestWithoutPayment")
        entry['sendRequestEmail'] = (val === "exit" && entry.toPay.startsWith('0') || val === "RequestWithoutPayment") ? "T" : "F"
        entry['RequestWithoutPayment'] = val === "RequestWithoutPayment"
        let response = await patientApi.editLeumitPatient(entry, entry.UserStorageID)
        localStorage.setItem('ProgrammChoosen', 'Y');

        if (response) {
            if (response && response.data && response.data.status === 400) {
                this.setState({isPageUploading: false})

                let confirm = await AlertConfirm({
                    options: {
                        cancelLabel: "none",
                        title: t('patient_boarding.mediator'),
                    }
                }, t('patient_boarding.mediatorExistError'))
                return;
            } else if (response && response.data && response.data.status === 250) {
                this.setState({isPageUploading: false})

                let confirm = await AlertConfirm({
                    options: {
                        cancelLabel: "none",
                        title: Couldnt_save_patient,
                    }
                }, t('patient_boarding.emailExist'))
                return;
            }
            localStorage.setItem('ProgrammRequestID', response.data.RequestID);
            let reqID = response.data.RequestID
            this.onValueChange("RequestID", reqID)
            this.setState({editMode: true, isPageUploading: false})
            let tranzilaToken = await patientApi.GenenrateTokenForTranzila(entry.RequestID)
            if (val === "exit" && !entry.toPay.startsWith('0')) {
                /*   history.push({
                       pathname: `/national_pain_management_RequestPayment`,
                       state: {
                           entry,
                           tranzilaToken: tranzilaToken.data,
                           from: {
                               fromPath: `/pain_patient_self_onboard`,
                           }
                       },
                   })*/
                entry['tranzilaToken'] = tranzilaToken.data
                this.setState({entry, view: 6})

            } else if (val === "exit" || val === "RequestWithoutPayment") {
                history.push('/national_pain_management_Request_Sent')
            } else {
                return response
            }
        } else {
            this.setState({isPageUploading: false})

            await makeError({
                proceedLabel: t('patient_self_boarding.ok'),
                options: {
                    title: Couldnt_save_patient,
                }
            }, [Couldnt_save_patient]);
            return;
        }

    }

    onClickPatientAllergics(event) {
        this.setState({patient_allergics: event})
    }

    onClickMedicationConditions = (conditionsList) => {
        this.setState({medicalConditionsSelected: conditionsList})
    }

    onClickAddDeleteMedications = (index, event, id, type) => {
        let {
            currentPain_medications,
            bloodThinner_medications,
            general_medications,
            isOtherPastUseMedication
        } = this.state
        let medications = []
        if (type === "CP") {
            medications = currentPain_medications
        } else if (type === "GEN") {
            medications = general_medications
        } else if (type === "BT") {
            medications = bloodThinner_medications
        }
        if (id === "Med_ID") {
            medications[event]['Med_ID'] = index.value
            medications[event]['Medication_name'] = index.label
            medications[event]['MedObj'] = index
        } else if (id === "past_med") {
            let indexOther = index.find((obj => obj.label === "Other"));
            this.onValueChange("PastUseOtherMed", " ")
            isOtherPastUseMedication = !!indexOther
            this.setState({past_med: index, isOtherPastUseMedication})
        } else {
            medications[index][id] = event
        }
        if (type === "CP") {
            this.setState({currentPain_medications: medications, isOtherPastUseMedication})
        } else if (type === "GEN") {
            this.setState({general_medications: medications, isOtherPastUseMedication})
        } else if (type === "BT") {
            this.setState({bloodThinner_medications: medications, isOtherPastUseMedication})
        }
    }

    addDeleteMedication(func, index) {
        let {currentPain_medications, general_medications, bloodThinner_medications} = this.state
        if (func === "addGen") {
            general_medications.push({index: index, General_Thinner_Past: "G"})
        } else if (func === "addThinner") {
            bloodThinner_medications.push({index: index, General_Thinner_Past: "T"})
        } else if (func === "addCP") {
            currentPain_medications.push({index: index, General_Thinner_Past: "CP"})
        } else if (func === "deleteCP") {
            currentPain_medications.splice(index, 1)
        } else if (func === "deleteThinner") {
            bloodThinner_medications.splice(index, 1)
        } else if (func === "deleteGen") {
            general_medications.splice(index, 1)
        }
        this.setState({general_medications, bloodThinner_medications, currentPain_medications})
    }

    getPatientAge(birthday) {
        if (birthday !== null) {
            let todayDate = new Date().toISOString()
            let todayExactDate = (todayDate.split('T'))[0].split('-')
            let currentYear = todayExactDate[0]
            let currentMonth = todayExactDate[1]
            let birthDate = birthday ? birthday.toISOString() : ""
            let exactDate = (birthDate.split('T'))[0].split('-')
            let yearDiff = currentYear - exactDate[0]
            let monthDiff = currentMonth - exactDate[1]
            if (monthDiff < 0) {
                return (yearDiff - 1) + "." + (12 + monthDiff)
            } else {
                return yearDiff + "." + (monthDiff)
            }
        }
        return ""
    }

    getFileFormDesc(index) {
        let {fileForms} = this.state
        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')
        let fromLanguage
        if (language === "he") {
            fromLanguage = "Form_desc_he"
        } else {
            fromLanguage = "Form_desc"
        }
        return fileForms[index][fromLanguage]
    }

    checkIfFileExists(Form_type_ID) {
        let {filesToUpload} = this.state
        for (let i = 0; i < filesToUpload.length; i++) {
            if (filesToUpload[i].Form_type_ID === Form_type_ID) {
                return true
            }
        }
        return false
    }

    onProgrammChoose(value) {
        let {entry, fileForms, filesToUpload, transporterFormIndex, psychiatricFormIndex} = this.state
        filesToUpload = []
        let transporterObj

        for (let i = 0; i < fileForms.length; i++) {
            if (fileForms[i].withPrescription === "T") {
                transporterFormIndex = i
                transporterObj = {
                    Form_type_ID: fileForms[i].Form_type_ID,
                    FormOrder: fileForms[transporterFormIndex].FormOrder,
                    FileUrl: [],
                    File_Name: [],
                    Form_desc: this.getFileFormDesc(i)
                }
            }
            if (fileForms[i].withPrescription === "P") {
                psychiatricFormIndex = i
            }
            let isNewRequest = value === "new" || value === "newPrescription"
            let isRenew2Request = value === "renew2" || value === "renew2Prescription"
            let isRenewRequest = value === "renew" || value === "renewPrescription"

            if (((entry.Psychiatric_diagnosis === "Yes" || entry.Nuclear_family_psychosis === "Yes" || entry.Drug_abuse === "Yes") &&
                    (isNewRequest || isRenew2Request) && fileForms[i].withPrescription === "P")
                || (fileForms[i].withPrescription === "A" && (value === "new" || value === "renew" || value === "renew2"))
                || ((fileForms[i].withPrescription === "N" || fileForms[i].withPrescription === "M") && isNewRequest)
                || (fileForms[i].withPrescription === "R" && isRenewRequest)
                || (fileForms[i].withPrescription === "C" && value === "change") ||
                ((fileForms[i].withPrescription === "N" || fileForms[i].withPrescription === "Y") && isRenew2Request)) {
                filesToUpload.push({
                    Form_type_ID: fileForms[i].Form_type_ID,
                    FormOrder: fileForms[i].FormOrder,
                    FileUrl: [],
                    File_Name: [],
                    Form_desc: this.getFileFormDesc(i)
                })
            }
        }

        if (entry.transporter === "Yes") {
            filesToUpload = filesToUpload.concat(transporterObj)
        }
        this.onValueChange('choose_programm', value)
        this.setState({transporterFormIndex, psychiatricFormIndex, filesToUpload})
    }

    deleteLeumitUploadedFile = async (index, fileIndex, fileName) => {
        let {entry, filesToUpload} = this.state
        let {t} = this.props
        let confirm = await AlertConfirm({
            proceedLabel: t('patient_self_boarding.continue'),
            cancelLabel: t('patient_self_boarding.cancel'),
            options: {
                title: '',
            }
        }, t('patient_self_boarding.deleteConfirm'))
        if (confirm) {
            let res = await patientApi.deleteLeumitUploadedFiles(entry.UserStorageID, filesToUpload[index].Form_type_ID, entry.RequestID, fileName)
            if (res) {
                filesToUpload[index].FileUrl.splice(fileIndex, 1)
                filesToUpload[index].File_Name.splice(fileIndex, 1)
            }
            this.setState({filesToUpload})
        }

    }

    saveSelectedFile = async (selectedFile, index) => {
        let {entry, filesToUpload} = this.state
        let requestID = entry.RequestID ? parseInt(entry.RequestID) : 0
        let fileToAdd = {
            selectedCategory: filesToUpload[index].Form_type_ID,
            file: selectedFile,
            UserStorageID: entry.UserStorageID,
            RequestID: requestID
        }
        let response = await patientApi.getLeumitUploadedFile(fileToAdd)
        if (response && response.data) {
            let responseArray = response.data.patientsFormsResult
            responseArray.map(item => {
                filesToUpload[index]['FileUrl'].push(item.Form_url)
                filesToUpload[index]['File_Name'].push(item.File_Name)
            })
        } else {
            await AlertConfirm({
                options: {
                    cancelLabel: "none",
                    title: `Bad File Extension`,
                }
            }, "PDF, PNG,JPEG, TIF,TXT, CSV, DOC")
        }

        this.setState({filesToUpload})
    }

    addFileObj = async (index, selectedCategory, selectedFile) => {
        this.setState({isUploadingFiles: true})
        let {addedFilesList, entry} = this.state
        if (selectedFile !== "" && selectedCategory !== "") {
            let fileToAdd = {
                selectedCategory: selectedCategory,
                file: selectedFile,
                UserStorageID: entry.UserStorageID,
                RequestID: entry.RequestID
            }
            let response = await patientApi.getLeumitUploadedFile(fileToAdd)
            if (response && response.data) {
                let responseArray = response.data.patientsFormsResult
                console.log("responseArray", responseArray)
                responseArray.map(item => {
                    addedFilesList.push(item)
                })
            } else {
                await AlertConfirm({
                    options: {
                        cancelLabel: "none",
                        title: `Bad File Extension`,
                    }
                }, "PDF, PNG,JPEG, TIF,TXT, CSV, DOC")
            }
        }
        this.setState({addedFilesList, isUploadingFiles: false})
    }

    async onclickHasLicense(code, value) {
        let {entry} = this.state
        let {t} = this.props
        let requestType = ""
        if (value === "Yes") {
            if (!entry.hasOldRequest) {
                requestType = entry.IsLicense ? "renew2" : "renew2Prescription"
            } else {
                requestType = entry.IsLicense ? "renew" : "renewPrescription"
            }
        } else {
            requestType = entry.IsLicense ? "new" : "newPrescription"
        }

        let getPaymentResponse = await patientApi.getPayment({
            requestType: requestType,
            hasLicenseLastYear: value,
            IsLicense: entry.IsLicense,
            IsIchilov: hasIchilovQuery(),
            Insuring_factor: entry.Insuring_factor,
            hasOldRequest: entry.hasOldRequest
        })
        let topay = getPaymentResponse ? getPaymentResponse.data.toPay : 0
        let hasRequestWithinTwoMonths = getPaymentResponse && getPaymentResponse.data && getPaymentResponse.data.patientRequestLastTwoMonths
        let hasApprovedRequest = getPaymentResponse && getPaymentResponse.data && getPaymentResponse.data.hasApprovedRequest
        let hasOpenRequest = getPaymentResponse && getPaymentResponse.data && getPaymentResponse.data.patientOpenRequest
        let message = t('patient_self_boarding.ToPayForRequest')
        message = message + "₪" + topay

        if (!hasApprovedRequest) {
            requestType = requestType === "renew" || requestType === "renewPrescription" ? entry.IsLicense ? "renew2" : "renew2Prescription" : requestType
        }

        this.onProgrammChoose(requestType)
        this.onValueChange("hasRequestWithinTwoMonths", !!hasRequestWithinTwoMonths || !!hasOpenRequest)
        this.onValueChange("toPay", topay)
        this.onValueChange(code, value)
        let elmntToView = document.getElementById('requestStartButton');
        if (elmntToView)
            elmntToView.scrollIntoView();
    }

    async showNoPaymentPopUp() {
        let {t} = this.props
        let confirm = await AlertConfirm({
            options: {
                proceedLabel: t('patient_self_boarding.continue'),
                cancelLabel: t('patient_self_boarding.cancel'),
                title: t('patient_self_boarding.proceedWithoutPayment'),
            }
        }, t('patient_self_boarding.proceedWithoutPaymentInfo'))

        if (confirm) {
            this.saveAllPatientData("RequestWithoutPayment")
        }
    }

    render() {
        let {view, entry} = this.state
        let {t} = this.props
        let PatientName = entry.First_name + ' ' + entry.Last_name
        let id = entry.ID_passport ? entry.ID_passport : ""

        let programm = entry.choose_programm ? entry.choose_programm : ""
        programm = programm === "new" ? t('patient_self_boarding.new_license') : programm
        programm = programm === "renew" ? t('patient_self_boarding.renew_license') : programm
        programm = programm === "renew2" ? t('patient_self_boarding.renew2_license') : programm
        programm = programm === "newPrescription" ? t('patient_self_boarding.new_Prescription') : programm
        programm = programm === "renewPrescription" ? t('patient_self_boarding.renew_Prescription') : programm
        programm = programm === "renew2Prescription" ? t('patient_self_boarding.renew2_Prescription') : programm

        let age = this.getPatientAge(entry.Date_of_birth)

        if (this.state.isPageUploading) {
            return <div className="loader"/>
        }


        return (
            <div>
                <div className={'asaya-info-selfOnboarding'}>
                    {this.state.docWidth > 1200 && <div className={'adminMargin-title-Leumit'}>
                        <div style={{width: '100%', display: 'flex'}}>
                            <div className="NewLeumitPatientTitle2">{PatientName}</div>
                        </div>
                        <div style={{display: 'flex'}}>
                            <div style={{display: 'flex', width: '85%'}}>

                                <div>
                                    <label className="NewLeumitPatientTitle">{t('patient_boarding.id_number')}</label>
                                    <label className="NewLeumitPatientTitleValue">{id}</label>
                                </div>
                                <div className={"title_splash"}/>
                                <div>
                                    <label className="NewLeumitPatientTitle">{t('patient_boarding.age')}</label>

                                    {entry.toPay && !entry.toPay.startsWith('0') && view === 5 ?
                                        <label className="NewLeumitPatientTitleValue"
                                               onClick={() => this.showNoPaymentPopUp()}>{age}</label>
                                        : <label className="NewLeumitPatientTitleValue">{age}</label>}


                                </div>

                            </div>

                        </div>

                    </div>}
                    {this.state.docWidth <= 1200 && view === 1 &&
                        <div className={'adminMargin-title-Leumit'}>
                            <div className="RequestChooseTitle">{t('patientPage.requestType')}</div>
                        </div>}

                    {this.state.docWidth <= 1200 && view !== 1 &&
                        <div className={'adminMargin-title-Leumit'}>
                            <div className="RequestChooseTitle">{programm}</div>
                        </div>}

                </div>
                <div className={'Patient-Screen'}>

                    {this.state.docWidth > 1200 && <div className={'contactSection'}>
                        <div className={'telClick'}>
                            <div style={{display: 'flex'}}>
                                <div
                                    style={{backgroundColor: '#f6f6f6', height: '62px', borderRadius: '0 35px 35px 0'}}>
                                    <SvGraphics svgname={'phone-icon'} width={'20px'} min-height={'20px'}
                                                style={{marginLeft: '8px', marginRight: '8px'}}/>

                                </div>
                                <div style={{padding: '13px'}}>
                                    <div className={'tel_label1'}>073-3807972</div>
                                    <div className={'tel_label2'}>{t('patient_self_boarding.workingHours')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    {view === 1 &&
                        <div className={'adminMargin-patientOnboard'} style={{marginTop: '45px'}}>
                            <PainProgrammChooseTab
                                onclickHasLicense={(name, value) => this.onclickHasLicense(name, value)}
                                onValueChange={(name, value) => this.onValueChange(name, value)}
                                onYesNoValueChange={(name, value) => this.onYesNoValueChange(name, value)}
                                entry={this.state.entry}
                                errors={this.state.errorsOnSave}
                                filesToUpload={this.state.filesToUpload}
                                t={e => this.props.t(e)}/>
                        </div>
                    }
                    {entry.choose_programm && view !== 1 && <div className={'adminMargin-patientOnboard'}>

                        {view !== 6 && <div className={'self-onboard-patientTabsMainBox'} id={'patientTabsMainBox'}>
                            <div tabIndex={0} className={view === 2 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(2)}>
                                <label
                                    className={view === 2 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_self_boarding.personal_details')}</label>
                            </div>
                            <div tabIndex={0} className={view === 3 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(3)}>
                                <label
                                    className={view === 3 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_self_boarding.Medical_information')}</label>
                            </div>
                            <div tabIndex={0} className={view === 4 ? 'patientTabsCurrBox' : 'patientTabsBoxes'}
                                 onClick={() => this.changeView(4)}>
                                <label
                                    className={view === 4 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_self_boarding.cannabis_patient')}</label>
                            </div>
                            <div tabIndex={0} className={view === 5 ? 'patientTabsCurrBox2' : 'patientTabsBoxes2'}
                                 onClick={() => this.changeView(5)}>
                                <label
                                    className={view === 5 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>{t('patient_self_boarding.declarations')}</label>
                            </div>

                            {/* <div tabIndex={0} className={view === 6 ? 'patientTabsCurrBox2' : 'patientTabsBoxes2'}
                                 onClick={() => this.changeView(6)}>
                                <label
                                    className={view === 6 ? 'patientTabsCurrBox-label' : 'patientTabsBoxes-label'}>Report</label>
                            </div>*/}


                        </div>}
                        {
                            view === 2 ? (
                                    <PainSelfPersonalDetailsTab
                                        onValueChange={(name, value) => this.onValueChange(name, value)}
                                        getPatientAge={(birthday) => this.getPatientAge(birthday)}
                                        addPsychiatricForm={(value) => this.addPsychiatricForm(value)}
                                        changeView={(view) => this.changeView(view)}
                                        onYesNoValueChange={(name, value) => this.onYesNoValueChange(name, value)}
                                        entry={this.state.entry}
                                        errors={this.state.errorsOnSave}
                                        israelCities={this.state.israelCities}
                                        cityList={this.state.cityList}
                                        t={e => this.props.t(e)}
                                    />)
                                : view === 3 ? (
                                    <PainSelfMedicalInfoTab
                                        onValueChange={(name, value) => this.onValueChange(name, value)}
                                        entry={this.state.entry}
                                        fileForms={this.state.fileForms}
                                        filesErrorOnSave={this.state.filesErrorOnSave}
                                        otherForms={this.state.otherForms}
                                        allergics={this.state.allergics}
                                        isUploadingFiles={this.state.isUploadingFiles}
                                        addFileObj={(index, selectedCategory, selectedFile) => this.addFileObj(index, selectedCategory, selectedFile)}
                                        saveSelectedFile={(selectedFile, index) => this.saveSelectedFile(selectedFile, index)}
                                        deleteLeumitUploadedFile={(index, fileIndex, fileName) => this.deleteLeumitUploadedFile(index, fileIndex, fileName)}
                                        deleteUploadedFile={(index) => this.deleteUploadedFile(index)}
                                        addedFilesList={this.state.addedFilesList}
                                        medicalConditions={this.state.medicalConditions}
                                        filesToUpload={this.state.filesToUpload}
                                        medicalConditionsSelected={this.state.medicalConditionsSelected}
                                        patient_allergics={this.state.patient_allergics}
                                        onClickPatientAllergics={(value) => this.onClickPatientAllergics(value)}
                                        onClickMedicationConditions={(value) => this.onClickMedicationConditions(value)}
                                        onYesNoValueChange={(name, value) => this.onYesNoValueChange(name, value)}
                                        errors={this.state.errorsOnSave}
                                        general_medications={this.state.general_medications}
                                        bloodThinner_medications={this.state.bloodThinner_medications}
                                        currentPain_medications={this.state.currentPain_medications}
                                        past_med={this.state.past_med}
                                        medicationsList={this.state.medicationsList}
                                        changeView={(view) => this.changeView(view)}
                                        onClickAddDeleteMedications={(index, event, id, type) => this.onClickAddDeleteMedications(index, event, id, type)}
                                        addDeleteMedication={(func, index) => this.addDeleteMedication(func, index)}
                                        t={e => this.props.t(e)}
                                    />) : view === 4 ? (
                                    <PainSelfUseOfCannabisTab
                                        onValueChange={(name, value) => this.onValueChange(name, value)}
                                        onClickCheckboxes={(name) => this.onClickCheckboxes(name)}
                                        onYesNoValueChange={(name, value) => this.onYesNoValueChange(name, value)}
                                        entry={this.state.entry}
                                        addedProducts={this.state.addedProducts}
                                        checkboxes={this.state.checkboxes}
                                        changeView={(view) => this.changeView(view)}
                                        errors={this.state.errorsOnSave}
                                        productsList={this.state.productsList}
                                        t={e => this.props.t(e)}
                                        onClickAddProducts={(func, value, index) => this.onClickAddProducts(func, value, index)}

                                    />) : view === 5 ? (
                                        <PainSelfDeclarationTab
                                            onValueChange={(name, value) => this.onValueChange(name, value)}
                                            onClickCheckboxes={(name) => this.onClickCheckboxes(name)}
                                            checkboxes={this.state.checkboxes}
                                            entry={this.state.entry}
                                            errors={this.state.errorsOnSave}
                                            t={e => this.props.t(e)}
                                        />)
                                    : view === 6 ? (
                                            <LeumitPayment entry={this.state.entry}
                                                           changeView={(view) => this.changeView(view)}/>)
                                        : <div>

                                        </div>
                        }
                        <div className={'backBox'}>
                            <div className={'backBoxRighting'} onClick={this.backButton.bind(this)}
                                 style={{display: view !== 1 && view !== 6 ? 'block' : 'none'}}>
                                {t('patient_self_boarding.back')}
                            </div>

                            <div className={view === 5 ? 'selfNextButton2' : 'selfNextButton'}
                                 onClick={() => this.saveAllPatientData("exit")}
                                 style={{display: view !== 5 ? 'none' : 'block'}}>
                                {!entry.toPay.startsWith('0') ? t('patient_self_boarding.gotopayment') : t('patient_self_boarding.sendRequest')}
                            </div>

                            <div className={view !== 1 && view !== 6 ? 'selfNextButton2' : 'selfNextButton'}
                                 onClick={() => this.nextButton()}
                                 style={{display: view !== 5 && view !== 6 ? 'block' : 'none'}}>
                                {t('patient_self_boarding.next')}
                            </div>

                        </div>

                    </div>}

                </div>
                {view === 1 && (entry.hasLicenseLastYear) &&
                    <div className={'requestStartButton'} id={'requestStartButton'} onClick={() => this.changeView(2)}>
                        {t('patient_self_boarding.requestStart')}
                    </div>
                }
                {view === 1 &&
                    <div className={'blankSpace'}/>}
            </div>
        )
    }

}

const PainPatientSelfOnBoard = compose(
    withTranslation(),
    connect(
        /*        mapStateToProps,
                mapDispatchToProps*/
    )
)(LeumitPatientSelfOnBoardConnected)

export default PainPatientSelfOnBoard;
